import React, { ChangeEvent, useState } from "react";
import CustomInput from "../customs/custom-input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import CustomSelect from "../customs/custom-select";
import CustomButton from "../customs/custom-button";
import { toast } from "react-toastify";
import { ParseErrors } from "../../utils/ParseErrors";
import axiosInstance from "../../utils/axiosInstance";
import Loader from "../loader";
import { User } from "../../providers/auth-provider";
import GetUser from "../../utils/getUser";
import ModalPortal from "../modal-portal";

interface TCreateAgentModel {
  ToggleModel: () => void;
  isEdit: User | boolean;
}

let userTypes = [
  { label: "Super Admin", value: "super-admin" },
  { label: "Admin", value: "admin" },
  { label: "Agent", value: "agent" },
];

const CreateAgentModel = ({ ToggleModel, isEdit }: TCreateAgentModel) => {
  const user = GetUser();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [values, setValues] = useState<any>({});
  const isUpdate = typeof isEdit !== "boolean" && isEdit?.id;

  const createUser = async () => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.post("/auth/register", values);
      toast.success(res.data.message);
      setIsLoading(false);
      ToggleModel();
    } catch (error) {
      console.log(error);
      toast.error(ParseErrors(error));
      setIsLoading(false);
    }
  };

  const updateUser = async () => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.put(
        `/user/update/${isUpdate && (isEdit as User).id}`,
        values
      );
      toast.success(res.data.message);
      setIsLoading(false);
      ToggleModel();
    } catch (error) {
      console.log(error);
      toast.error(ParseErrors(error));
      setIsLoading(false);
    }
  };

  const onChangeValues = (e: ChangeEvent<HTMLInputElement>) => {
    setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <ModalPortal>
      <div
        className="z-[99999] fixed inset-0 bg-black/60 backdrop-blur-sm flex items-start justify-center overflow-y-auto py-6 sm:py-10 px-3 sm:px-5 animate-fade-in"
        onClick={ToggleModel}
      >
        <div
          className="bg-surface-elevated border border-edge w-full max-w-[520px] rounded-2xl shadow-card"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between py-4 px-6 border-b border-edge sticky top-0 bg-surface-elevated rounded-t-2xl z-10">
            <h2 className="font-heading-font text-[22px] sm:text-[25px] text-text-primary">
              {isUpdate ? "Update" : "Create"} User
            </h2>
            <button
              onClick={ToggleModel}
              className="h-9 w-9 flex items-center justify-center rounded-lg border border-edge bg-overlay text-text-primary hover:border-indigo-400/40 transition-all"
              aria-label="Close"
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>

          <div className="p-5 sm:p-8">
            <CustomInput
              autoComplete="none"
              label="Full Name"
              defaultValue={isUpdate ? (isEdit as User)?.name : ""}
              name="name"
              onChange={onChangeValues}
            />
            <div className="my-4"></div>
            <CustomInput
              autoComplete="none"
              label="Email"
              defaultValue={isUpdate ? (isEdit as User)?.email : ""}
              name="email"
              onChange={onChangeValues}
            />
            <div className="my-4"></div>
            <CustomInput
              autoComplete="none"
              label="Phone"
              defaultValue={isUpdate ? (isEdit as User)?.phone : ""}
              name="phone"
              onChange={onChangeValues}
            />
            <div className="my-4"></div>
            <CustomInput
              autoComplete="none"
              label="User Code"
              defaultValue={isUpdate ? (isEdit as User)?.code : ""}
              name="code"
              onChange={onChangeValues}
            />
            <div className="my-4"></div>
            <CustomInput
              autoComplete="none"
              label="Password"
              name="password"
              onChange={onChangeValues}
            />
            <div className="my-4"></div>
            <CustomSelect
              comboboxType="select"
              label="User Type"
              labelProperty="label"
              valueProperty="value"
              options={
                user.type === "super-admin"
                  ? userTypes
                  : userTypes.filter((userT) => userT.value !== "super-admin")
              }
              onSingleSelectChange={(option) =>
                setValues((prev) => ({ ...prev, type: option?.value }))
              }
              value={userTypes.find(
                (type) =>
                  type.value ===
                  (isUpdate ? (isEdit as User)?.type : values?.type)
              )}
            />
            <div className="my-6"></div>
            <CustomButton
              disabled={isLoading}
              fullWidth
              variant="primary"
              className="w-full"
              onClick={isUpdate ? updateUser : createUser}
            >
              {isLoading ? <Loader /> : isUpdate ? "UPDATE" : "SUBMIT"}
            </CustomButton>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default CreateAgentModel;
